module.exports = "<h2 id=\"component-description\">Component Description</h2>\n<p>A Nessie TextArea consists of a text area <code>&lt;input&gt;</code>.</p>\n<h2 id=\"example-usage\">Example Usage</h2>\n<pre><code>&lt;TextArea placeholder = &quot;Please enter max. 500 characters&quot;/&gt;\n</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./node_modules/markdown-loader!./src/TextArea/README.md
// module id = 404
// module chunks = 0